import { render } from "./GroupPanel.vue?vue&type=template&id=06031fd4&scoped=true"
import script from "./GroupPanel.vue?vue&type=script&lang=ts"
export * from "./GroupPanel.vue?vue&type=script&lang=ts"

import "./GroupPanel.vue?vue&type=style&index=0&id=06031fd4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06031fd4"

export default script